import * as Dialog from '@radix-ui/react-dialog';
import { CheckFat, X } from 'phosphor-icons';
import { c } from '../../../utils/tailwind-merge';
import { FeedbackConfirmationProps } from './FeedbackConfirmation.types';

export const FeedbackConfirmation = ({
  microcopy,
  className = '',
}: FeedbackConfirmationProps) => (
  <Dialog.Root defaultOpen>
    <Dialog.Portal>
      <Dialog.Overlay className="fixed inset-0 bg-black/40" />
      <Dialog.Content
        className={c(
          'fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2',
          'w-64 rounded-lg bg-white p-4 text-center text-grey-900 focus-visible:outline-transparent',
          className
        )}
      >
        <Dialog.Close asChild>
          <div className="mb-16 flex items-center justify-end">
            <X size={24} weight="bold" className="cursor-pointer" />
          </div>
        </Dialog.Close>
        <CheckFat
          weight="bold"
          className="mx-auto text-success-800"
          size={80}
        />
        <Dialog.Title className="mb-5 mt-16 text-2xl font-semibold">
          {microcopy.title}
        </Dialog.Title>
        <Dialog.Description className="text-sm">
          {microcopy.subtitle}
        </Dialog.Description>
      </Dialog.Content>
    </Dialog.Portal>
  </Dialog.Root>
);
